module.exports = {"server":"https://pemm.agetic.gob.bo/ws","serverAuth":"https://pemm.agetic.gob.bo/ws","timeSessionExpired":30,"debug":true,"onbeforeunload":false,"port":3100,"subDomain":"/","portDev":8888}


//////////////////
// WEBPACK FOOTER
// ./config.json
// module id = 147
// module chunks = 0